import { useState, useEffect } from 'react'
import { LevelCompletionScreenContent, LevelCompletionVariant } from 'utils/constants'
import { COUNTDOWN_TICK_MS, COUNTDOWN_DURATION_MS } from './LevelCompletionScreen'
import {
    pushLevelCompletionAutoRedirectCompleted,
    pushLevelCompletionPageViewed
} from './levelCompletionAnalytics'
import { FooterSection, CountdownMessage, CountdownProgress, StayOnPageMessage } from './styles'

export const AutoRedirectSection: React.FC<{ onContinue: () => void }> = ({ onContinue }) => {
    const [progressValue, setProgressValue] = useState(0)

    useEffect(() => {
        pushLevelCompletionPageViewed(LevelCompletionVariant.AUTO_REDIRECT)
    }, [])

    useEffect(() => {
        let elapsedMs = 0
        const intervalId = window.setInterval(() => {
            elapsedMs += COUNTDOWN_TICK_MS
            const progress = Math.min(100, (elapsedMs / COUNTDOWN_DURATION_MS) * 100)
            setProgressValue(progress)

            if (progress >= 100) {
                window.clearInterval(intervalId)
                pushLevelCompletionAutoRedirectCompleted()
                onContinue()
            }
        }, COUNTDOWN_TICK_MS)

        return () => {
            window.clearInterval(intervalId)
        }
    }, [onContinue])

    return (
        <FooterSection data-testid='level-completion-auto-redirect'>
            <CountdownMessage variant='body1'>
                {LevelCompletionScreenContent.countdownMessage}
            </CountdownMessage>
            <CountdownProgress
                variant='determinate'
                value={progressValue}
                aria-label={LevelCompletionScreenContent.countdownMessage} />
            <StayOnPageMessage variant='subtitle2'>
                {LevelCompletionScreenContent.stayOnPage}
            </StayOnPageMessage>
        </FooterSection>
    )
}
